<p-dialog
  [header]="competition.name"
  [(visible)]="showForm"
  [breakpoints]="{ '960px': '75vw' }"
  [style]="{ width: '90vw', height: '80vh', top: '1.5rem' }"
  [modal]="true"
  [draggable]="false"
  [resizable]="true"
  (onHide)="closeDialog()"
  [maximizable]="true"
>
<div class="card">
  <p-tabView
    styleClass="tabview-custom"
    [(activeIndex)]="activeTabIndex"
    (onChange)="onTabChange($event)"
  >
    <p-tabPanel header="Inscripción General">
      <ng-template pTemplate="header">
        <div class="flex align-items-center gap-2">
          <span class="font-bold white-space-nowrap m-0"> Inscripción General </span>
        </div>
      </ng-template>
      <div *ngIf="showMembersRegisters" class="p-mt-2">
        <div class="flex align-items-center gap-2 mb-3 text-sm" style="color: #64748b">
          <i class="pi pi-info-circle"></i>
          <span>
            Esta pestaña lista únicamente las inscripciones exitosas
            ({{ registrations.length }} de {{ allRegistrations.length }} registros).
            Usa la pestaña <strong>Vista Avanzada</strong> para consultar todos los
            clubes o escuelas con sus inscripciones completas y sus estados.
          </span>
        </div>
        <app-registrations-table
          [registrations]="registrations"
          [categories]="categories"
          [levels]="Levels"
          [competition]="competition"
          ></app-registrations-table>
      </div>
    </p-tabPanel>
    <p-tabPanel header="Vista Avanzada">
      <ng-template pTemplate="header">
        <div class="flex align-items-center gap-2">
          <span class="font-bold white-space-nowrap m-0"> Vista Avanzada </span>
        </div>
      </ng-template>
      <div *ngIf="showAdvancedRegisters" class="p-mt-2">
        <app-advanced-registrations
          [competition]="competition"
          [registrations]="allRegistrations"
          [categories]="categories"
          [levels]="Levels"
          (registrationsUpdated)="refreshRegistrationsDerived()"
        ></app-advanced-registrations>
      </div>
    </p-tabPanel>
    <p-tabPanel header="Inscripción Clubes" [disabled]="true">
      <ng-template pTemplate="header">
        <div class="flex align-items-center gap-2">
          <span class="font-bold white-space-nowrap m-0"> Inscripción Pruebas </span>
        </div>
      </ng-template>
      <div *ngIf="showClubesRegisters" class="p-mt-2">
          
      </div>
    </p-tabPanel>
    <p-tabPanel header="Resumen Financiero">
      <ng-template pTemplate="header">
        <div class="flex align-items-center gap-2">
          <span class="font-bold white-space-nowrap m-0">Resumen Financiero</span>
        </div>
      </ng-template>
      <div *ngIf="showFinancialResumen" class="p-mt-2">
        <app-financial-report
        [competition]="competition"
        [registrations]="registrations"
        ></app-financial-report>
      </div>
    </p-tabPanel>

  </p-tabView>
</div>

</p-dialog>